<div class="auth-organization-selection-modal">
  <header class="header">
    @if (userProfile()?.avatar; as avatar) {
      <evc-avatar
        [avatar]="avatar"
        size="xl"
        class="user-avatar" />
    }
    <p class="title">{{ welcome() }}</p>
    <p class="email">{{ userProfile()?.email }}</p>
  </header>

  <div class="divider-bar"></div>

  <section>
    <p class="subtitle">
      {{ chooseOrgLabel() }}
    </p>
    @for (org of organizations(); track org.id) {
      <evc-menu-item
        [badgeItem]="org"
        [aditionalText]="org.additionalText"
        [disabled]="!org.hasAccess"
        (organizationClicked)="orgSelected.emit($event.id)" />
    }
  </section>

  <div class="divider-bar"></div>

  <button
    class="action"
    (click)="useAnotherAccount.emit()">
    <evc-avatar
      size="md"
      [avatar]="useAnotherAccountAvatar" />
    <span class="org-item__name">{{ useAnotherAccountLabel() }}</span>
  </button>
  <button
    class="action"
    (click)="logout()">
    <evc-avatar
      size="md"
      [avatar]="logoutAvatar" />
    <span class="org-item__name">{{ logoutLabel() }}</span>
  </button>
</div>
